import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import { LoggingMessageService } from './logging-message.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class PendoService {

  private isPendoInitialized = false;
  private user: string;

  constructor(private authService: AuthService,  private storageService: StorageService, private logger: LoggingMessageService) {
    // this.logger.debug('', 'CacheService', 'Creating new Cache');
  }

  public checkPendo(w: any, sub: string, availableSubs: string) {
    // const w: any = window;
    this.user = this.authService.getTokenEmail();
    if (this.user && !this.isPendoInitialized) {
        this.logger.info('pendo.service', 'checkPendo',+sub, availableSubs, 'checking', '');
        if (w && w.pendo && w.pendo.getVisitorId) {
            this.logger.info('pendo.service', 'checkPendo', +sub, availableSubs, 'Pendo is installed', '');
            const visitor = w.pendo.getVisitorId();
            this.logger.info('pendo.service', 'checkPendo', +sub, availableSubs, `Visitor: ${visitor}`, '');
            // if ( (visitor === null) || (typeof visitor === 'undefined') ) {
            this.initializePendo(w, sub, availableSubs);
            // }
        }
    }
  }

  private initializePendo(w: any, sub: string, availableSubs: string) {
    this.logger.info('pendo.service', 'initializePendo', +sub, availableSubs,'initializing', '');

    // const w: any = window;
    if (w.pendo && w.pendo.initialize) {
      const visitor = this.storageService.getPendoUserId();
      const hospid = this.storageService.getSelectedHospitalId();
      const hospname = this.storageService.getSelectedHospitalName();
      this.logger.info('pendo.service', 'initializePendo', +sub, availableSubs, `Window:${w.name}, Visitor:${visitor}, HospId:${hospid}, HospName: ${hospname}`, '');

      w.pendo.initialize({
          visitor: {
              id: visitor   // Required if user is logged in
          },
          account: {
              id: hospid,
              accountName: hospname
          }
      });

      this.isPendoInitialized = true;
    }
  }

  public updatePendo(w: any, sub: string, availableSubs: string) {
      this.logger.info('pendo.service', 'updatePendo', +sub, availableSubs,`updating`, '');
      // let visitor = this.user;
      let visitor = this.storageService.getPendoUserId();
      const hospid = this.storageService.getSelectedHospitalId();
      const hospname = this.storageService.getSelectedHospitalName();
      if (hospname && (hospname.length > 0) && (w)) {
        if ((w.pendo) && (w.pendo.getVisitorId)) {
          visitor = w.pendo.getVisitorId();
          w.pendo.updateOptions({
                account: {
                  id: hospid,
                  accountName: hospname
                }
          });
          this.logger.info('pendo.service', 'updatePendo', +sub, availableSubs,`Window: ${w.name}, visitor:${visitor}, account:${hospname}`, '');
        } else {
          //  this.logger.warning(this.user, 'IF PendoService updatePendo', `visitor:${visitor}, account:${hospname} - Pendo is being blocked by this hospital`);
        }
      }
    }
}
